var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"nodata"},[_c('div',[_c('img',{attrs:{"src":require("../assets/no.png")}})]),_c('div',[_vm._v("暂无数据")])])])}]

export { render, staticRenderFns }